import { EquipmentDropdownInput } from "#batteries-included-components/Dropdowns/EquipmentDropdownInput";
import { FacilityDropdownInput } from "#batteries-included-components/Dropdowns/FacilityDropdownInput";
import { useCustomAttributeFilters } from "#hooks/FilterPanel/useCustomAttributeFilters";
import {
  useListFlowProductCategories,
  useListFlowProductTypes,
  useListFlowTypes,
} from "#hooks/adapters/useFlows";
import {
  DropdownInput,
  FilterPanel,
  StorageKeys,
  TextInput,
} from "@validereinc/common-components";
import { AssetType } from "@validereinc/domain";
import { Flows } from "@validereinc/domain-controllers";
import React from "react";

const { FlowStatusOptions } = Flows.view;

export const NetworkFlowsFilterPanel = ({
  filterConfigStorageKey,
}: Pick<StorageKeys, "filterConfigStorageKey">) => {
  const flowTypesQuery = useListFlowTypes();
  const productCategoriesQuery = useListFlowProductCategories();
  const productTypesQuery = useListFlowProductTypes();
  const { customAttributeFilters } = useCustomAttributeFilters({
    assetType: AssetType.FLOW,
  });

  return (
    <FilterPanel
      storageKey={filterConfigStorageKey}
      defaultActiveKeys={["Filters"]}
      filters={[
        {
          component: (
            <TextInput
              name="name"
              key="flows-name-filter"
              placeholder="Search Flows..."
              type="search"
              isInline
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <DropdownInput
              name="type"
              label="Flow Type"
              options={flowTypesQuery.data?.data ?? []}
              labelKey="name"
              valueKey="id"
              isMulti
              isFluid
              isSearchable
              isOptionalTextShown={false}
              key="flow-type-filter"
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <DropdownInput
              key="status"
              name="status"
              label="Status"
              options={FlowStatusOptions}
              labelKey="label"
              valueKey="value"
              isMulti
              isFluid
              isSearchable
              isOptionalTextShown={false}
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <DropdownInput
              name="product_category"
              label="Product Category"
              options={productCategoriesQuery.data?.data ?? []}
              labelKey="name"
              valueKey="id"
              isMulti
              isFluid
              isSearchable
              isOptionalTextShown={false}
              key="product-category-filter"
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <DropdownInput
              name="product_type"
              label="Product Type"
              options={productTypesQuery.data?.data ?? []}
              labelKey="name"
              valueKey="id"
              isMulti
              isFluid
              isSearchable
              isOptionalTextShown={false}
              key="product-type-filter"
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <FacilityDropdownInput
              key="associated_facility_id"
              name="associated_facility_id"
              isMulti
              isFluid
              isOptionalTextShown={false}
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <EquipmentDropdownInput
              key="associated_equipment_id"
              name="associated_equipment_id"
              isMulti
              isFluid
              isOptionalTextShown={false}
            />
          ),
        },
        ...customAttributeFilters,
      ]}
    />
  );
};
